<template>
    <div class="product-insights">
      <carousel :per-page="4" :navigationEnabled="true" :mouse-drag="false">
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-8">
                <h3>Lead Conversion Rate:</h3>
                <h2>{{ leadConversionRateNumber }}</h2>
              </div>
              <div class="col-md-4">
                 <h5 class="brown_line">{{ leadConversionRate }}%</h5>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-8">
                <h3>Sales Conversion Rate:</h3>
                <h2>{{ SalesConversionRateNumber }}</h2>
              </div>
              <div class="col-md-4">
                 <h5>{{ SalesConversionRate }}%</h5>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-8">
                <h3>Retention Rate:</h3>
                <h2>{{ retentionRateNumber }}</h2>
              </div>
              <div class="col-md-4">
                 <h5 class="brown_line">{{ retentionRate }}%</h5>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-8">
                <h3>Upsell Ratio:</h3>
                <h2>{{ upsellRatioNumber }}</h2>
              </div>
              <div class="col-md-4">
                 <h5>{{ upsellRatio }}%</h5>
              </div>
              </div>
            </div>
        </slide>

      </carousel>
      <!-- <h4 v-show="loading" style="text-align: center;">Loading Products Insights...</h4> -->
    </div>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'ProductInsights',
  components: {
    Carousel,
    Slide
  },
  props: ['brandId', 'leadConversionRate', 'SalesConversionRate', 'retentionRate', 'upsellRatio', 'leadConversionRateNumber', 'SalesConversionRateNumber', 'retentionRateNumber', 'upsellRatioNumber'],
  data: function () {
    return {
      loading: true,
      localTime: '',
      selfies: [],
      image: '',
      userName: '',
      storeName: '',
      storeAddress: '',
      slickOptions: {
        slidesToShow: 3
      }
    }
  },
  methods: {
    next () {
      this.$refs.slick.next()
    },

    prev () {
      this.$refs.slick.prev()
    },

    reInit () {
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },

    handleAfterChange (event, slick, currentSlide) {
      console.log('handleAfterChange', event, slick, currentSlide)
    },
    handleBeforeChange (event, slick, currentSlide, nextSlide) {
      console.log('handleBeforeChange', event, slick, currentSlide, nextSlide)
    },
    handleBreakpoint (event, slick, breakpoint) {
      console.log('handleBreakpoint', event, slick, breakpoint)
    },
    handleDestroy (event, slick) {
      console.log('handleDestroy', event, slick)
    },
    handleEdge (event, slick, direction) {
      console.log('handleEdge', event, slick, direction)
    },
    handleInit (event, slick) {
      console.log('handleInit', event, slick)
    },
    handleReInit (event, slick) {
      console.log('handleReInit', event, slick)
    },
    handleSetPosition (event, slick) {
      console.log('handleSetPosition', event, slick)
    },
    handleSwipe (event, slick, direction) {
      console.log('handleSwipe', event, slick, direction)
    },
    handleLazyLoaded (event, slick, image, imageSource) {
      console.log('handleLazyLoaded', event, slick, image, imageSource)
    },
    handleLazyLoadError (event, slick, image, imageSource) {
      console.log('handleLazeLoadError', event, slick, image, imageSource)
    },

    getBrandSocialSelfies () {
      this.$store.dispatch('getBrandSocialSelfies', this.brandId)
        .then(
          (response) => {
            // console.log(response.body)
            this.selfies = response.body
            this.loading = false
            this.showLocaleTime()
            this.image = this.selfies[0]['image'] + '?width=300'
            this.storeAddress = this.selfies[0]['address']
            this.userName = this.selfies[0]['name']
            this.storeName = this.selfies[0]['store']
          }
        )
    },
    showLocaleTime: function () {
      var here = this
      let counter = 1
      setInterval(function () {
        here.image = here.selfies[counter]['image'] + '?width=300'
        here.storeAddress = here.selfies[counter]['address']
        here.userName = here.selfies[counter]['name']
        here.storeName = here.selfies[counter]['store']
        counter++
        if (counter === (here.selfies.length - 1)) {
          counter = 0
        }
      }, 5000)
    }
  },

  mounted () {
    // this.getBrandSocialSelfies()

  },
  watch: {
  }
}
</script>
<style>
.VueCarousel-pagination{
  display: none;
}
.metrics-box {
    width: 94%;
    margin: 10px 3%;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);
    padding: 10px;
    text-align: center;
}
.metrics-box h3{
    font-size: 14px;
    color: #000;
    line-height: 23px;
}
.metrics-box h2{
    font-size: 20px;
    color: #000;
    line-height: 23px;
    min-height: 23px;
}
.metrics-box h5{
    background: #d2eadd;
    width: 60px;
    line-height: 54px;
    border-radius: 100%;
    margin-top: 20px;
    border: 2px solid #BDA340;
    font-size: 18px;
}
.brown_line{
  border: 2px solid #641c44 !important;
  background: #DCC8D3 !important;
}
</style>
